module.exports = __webpack_public_path__ + "4.3.2/img/car_X2.49473611.png";